module.exports = __webpack_public_path__ + "static/img/ic_gy_d_a@2x.545b35a2.png";